import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://biblekpykkdimytprmvt.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJpYmxla3B5a2tkaW15dHBybXZ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI5MzA2NDgsImV4cCI6MjA4ODUwNjY0OH0.e-0HUVpfkU1cw18P6aEKuuqq4HHikzsGUOx0Xld924M'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})